import { type ChipProps } from "./chip";
import {
    getAdornmentsHeight,
    getAdornmentsSvgSize,
    getBackgroundColor,
    getBorderColor,
    getBorderRadius,
    getColor,
    getFontSize,
    getLineHeight,
    getPadding,
} from "./chip.styles.utils";
import { createShouldForwardPropBlockList, deepMerge } from "@components/common/utils/helper";
import styled from "styled-components";

type BodyProps = Pick<ChipProps, "color" | "fullTone" | "outline" | "label" | "rounded" | "size">;
type AdornmentsProps = Pick<ChipProps, "size">;

export const Wrapper = styled("div")(() => ({
    display: "flex",
    alignItems: "center",
    fontSize: "0px",
}));

export const Body = styled("div").withConfig({
    shouldForwardProp: createShouldForwardPropBlockList(["color", "fullTone", "outline", "label", "rounded", "size"]),
})<BodyProps>(({ color, fullTone = false, outline = false, label, rounded, size, theme }) => ({
    borderWidth: theme.borderWidth.DEFAULT,
    fontWeight: theme.fontWeight.medium,
    borderStyle: "solid",
    display: "inline-flex",
    gap: theme.spacing[1.5],
    alignItems: "center",
    ...deepMerge(
        getBackgroundColor(color, fullTone, outline, theme),
        getColor(color, fullTone, outline, theme),
        getFontSize(size, theme),
        getLineHeight(size),
        getPadding(size, label, theme),
        getBorderRadius(rounded, theme),
        getBorderColor(color, fullTone, theme),
    ),
}));

export const Label = styled("div")(() => ({
    display: "block",
}));

export const Adornments = styled("div").withConfig({
    shouldForwardProp: createShouldForwardPropBlockList(["size"]),
})<AdornmentsProps>(({ size, theme }) => ({
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ...deepMerge(getAdornmentsHeight(size, theme)),
    "& svg": {
        ...deepMerge(getAdornmentsSvgSize(size, theme)),
    },
}));
